var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.3335,
    y: 8.33331,
    width: 14.5833,
    height: 14.5833,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0835 9.83331C27.0835 9.00488 27.7551 8.33331 28.5835 8.33331H40.1668C40.9953 8.33331 41.6668 9.00489 41.6668 9.83331V21.4166C41.6668 22.2451 40.9953 22.9166 40.1668 22.9166H28.5835C27.7551 22.9166 27.0835 22.2451 27.0835 21.4166V9.83331ZM8.3335 28.5833C8.3335 27.7549 9.00507 27.0833 9.8335 27.0833H21.4168C22.2453 27.0833 22.9168 27.7549 22.9168 28.5833V40.1666C22.9168 40.9951 22.2453 41.6666 21.4168 41.6666H9.83349C9.00507 41.6666 8.3335 40.9951 8.3335 40.1666V28.5833ZM28.5835 27.0833C27.7551 27.0833 27.0835 27.7549 27.0835 28.5833V40.1666C27.0835 40.9951 27.7551 41.6666 28.5835 41.6666H40.1668C40.9953 41.6666 41.6668 40.9951 41.6668 40.1666V28.5833C41.6668 27.7549 40.9953 27.0833 40.1668 27.0833H28.5835Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/Blocks.a1122721d011f0f9af7c7eaa590c8769.svg";
export { ForwardRef as ReactComponent };